import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TimetableInfoPage } from './timetable-info';

@NgModule({
  declarations: [
    TimetableInfoPage,
  ],
  imports: [
    IonicPageModule.forChild(TimetableInfoPage),
  ],
})
export class TimetableInfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/timetable-info/timetable-info.module.ts